<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      label-width="68px"
    >
      <el-form-item label="关键字" prop="key">
        <el-input
          v-model="queryParams.condition.key"
          placeholder="请输入关键字"
          clearable
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="userList"
      :row-style="{ height: '58px' }"
      height="calc(100vh - 290px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      tooltip-effect="dark myTooltips"
      border
    >
      <el-table-column
        label="任务编号"
        align="center"
        prop="taskNo"
        width="150"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="项目名称"
        align="center"
        prop="projectName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务名称"
        align="center"
        prop="taskName"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务描述"
        align="center"
        prop="taskDescription"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="服务内容"
        align="center"
        prop="serveContent"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div class="content" v-html="scope.row.serveContent"></div>
        </template>
      </el-table-column>
      <el-table-column
        label="处理结果"
        align="center"
        prop="handleResult"
        :show-overflow-tooltip="true"
      >
      </el-table-column>

      <el-table-column
        label="任务处理人"
        align="center"
        prop="personNames"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        label="任务状态"
        align="center"
        prop="taskStatus"
        width="100"
      >
        <template slot-scope="scope">
          <el-tag type="info">{{
            scope.row.taskStatus | StatusFiltering
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="150"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
          <el-button
            size="mini"
            type="info"
            icon="el-icon-download"
            v-if="scope.row.orderFileUrl != ''"
            style="margin-left: 10px"
            @click="handleDownload(scope.row)"
            >工单附件</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      :pageSizes="[50, 100, 200, 500]"
      @pagination="getList"
    />
    <el-dialog
      :title="title + '详情'"
      :visible.sync="dialogVisible"
      width="45%"
      :before-close="handleClose"
    >
      <my-timeline :events="timelineEvents" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { orderTaskPage, getistByTaskId } from "@/api/work/WorkTaskList";
import MyTimeline from "@/components/Timeline";
import { downloadFileByPost } from "@/utils/filenRequest.js";
export default {
  components: {
    MyTimeline,
  },

  data() {
    return {
      title: "",
      userList: [],
      IP: this.$store.state.IPAss.TP,
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      // 非多个禁用
      multiple: true,
      dialogVisible: false,
      timelineEvents: [],
      base64: "",
      updateTime: "",
      queryParams: {
        limit: 50,
        page: 1,
        condition: {
          orderStatus: "finish",
          key: "",
        },
        orderBy: "",
      },
    };
  },
  created() {
    this.getList();
  },

  methods: {
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data } = await orderTaskPage(this.queryParams);
      this.userList = data.records;
      this.total = data.total;
      this.loading = false;
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    async handleDetail(row) {
      this.title = row.orderName;
      let { data } = await getistByTaskId(row.taskId);
      this.timelineEvents = data;
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //附件下载
    async handleDownload(url) {
      downloadFileByPost(url.orderFileUrl);
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.condition.key = undefined;
      this.getList();
    },
  },
};
</script>
  
<style>
.content img {
  max-width: 100%;
}
.content {
  /* height: 58px; */
}
.myTooltips {
  /* width: 70%; */
}
</style>